import { useCallback } from "react";
import { StorageScope } from "../../../../services/api/instances/storageApi/types/service_types";
import { useAppDispatch } from "../../../../services/redux/hooks/use-dispatch";
import { removeStorageObject } from "../../../../app/state/storageObjectSlice/actions/actions";
import { useStorageSelectors } from "../../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { deleteStoreAction } from "../../../../features/Database/redux/actions/openai_store_actions";
import { useModalSelectors } from "../../../../app/state/modalSlice/hook/use-modal-selectors";

export const useDeleteObjectModal = (service: StorageScope) => {
  const dispatch = useAppDispatch();
  const deleteModal = useModalSelectors("delete_modal");
  const { selectedId, objects, entities } = useStorageSelectors(service);

  const handleDelete = useCallback(
    (id: string) => {
      if (service === "knowledge_base") {
        dispatch(deleteStoreAction(id));
        return;
      }
      dispatch(
        removeStorageObject({
          id: id,
          service,
        }),
      ).unwrap();
    },
    [selectedId, entities, objects, service],
  );

  return {
    deleteModal,
    handleDelete,
  };
};
